import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import { useAppSelector } from '@/utils/redux';

/**
 * Whether Ask AllTrails mode is on, for any page that hosts it. Ask should stay on as the user moves between pages.
 */
const useIsAskActive = () => {
  const isAskEnabled = useExperiments()['web-disco-rm-ask-alltrails']?.value === 'treatment';
  const isActive: boolean = useAppSelector(state => state.ask.isActive);

  return isAskEnabled && isActive;
};

export default useIsAskActive;
